export const employeeCode = "EmployeeCode";
export const primaryEmployeeID = "PrimaryEmployeeID";
export const secondaryEmployeeID = "SecondaryEmployeeID";
export const formerEmployeeID = "FormerEmployeeID";
export const badgeNo = "BadgeNo";
export const clockNo = "ClockNo";
